import {extendObservable, action, decorate} from 'mobx';
import * as R from 'ramda/src/index';
import Tab from './tab-model';
import {getSearchResults} from 'providers/metasearch';

class ResultsTabsStore {
  constructor(resultsEventsChannel, searchMaskStopLoading) {
    extendObservable(this, {
      selectedIndex: -1,
      tabs: []
    });

    Object.assign(this, {resultsEventsChannel, searchMaskStopLoading});
  }

  closeTab = (selectedIndex) => {
    this.tabs.remove(this.tabs[selectedIndex]);
    this.selectedIndex = selectedIndex === 0 ? 0 : selectedIndex - 1;
    window.location.hash = this.tabs[this.selectedIndex].searchQuery.url;
  };

  changeTab = (selectedIndex) => {
    this.selectedIndex = selectedIndex;
    window.location.hash = this.tabs[selectedIndex].searchQuery.url;
  };

  goToTab = (searchQuery) => {
    const existingIndex = R.findIndex(({searchQuery: {url}}) => url === searchQuery.url, this.tabs);
    if (existingIndex > -1) {
      this.selectedIndex = this.tabs[existingIndex];
      return;
    }
    const newTab = new Tab({
      resultsProvider: getSearchResults(searchQuery),
      searchQuery,
      searchMaskStopLoading: this.searchMaskStopLoading,
      resultsEventsChannel: this.resultsEventsChannel
    });
    this.tabs.push(newTab);
    this.selectedIndex = this.tabs.length - 1;
    this.resultsEventsChannel.publish('search.change', {searchQuery});
  };
}

decorate(ResultsTabsStore, {
  closeTab: action,
  changeTab: action,
  goToTab: action
});

export default ResultsTabsStore;
